import React from "react";
import { useParams } from "react-router-dom";
import { CampaignEmailTemplate } from "./CampaignEmailTemplate";
import { useQueryParam } from "helpers/queryParam/useQueryParam";

export const CampaignEmailTemplatePage: React.FC = () => {
  const { campaignUid } = useParams<{ campaignUid: string }>();
  const [emsUserToken] = useQueryParam("ems_user_token");

  if (!campaignUid) {
    return <div>looks like you got the wrong url.</div>;
  }
  return (
    <CampaignEmailTemplate
      campaignUid={campaignUid}
      emsUserToken={emsUserToken}
    />
  );
};
